<div class="NgxEditor__Wrapper">
	<ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
	<ngx-editor placeholder="{{ placeholder || 'Type Here...' }}" [editor]="editor" [ngModel]="htmlText" [disabled]="false" (ngModelChange)="onChange($event)"></ngx-editor>
</div>
